
import { API } from "../constants/api";
import {
  axiosPostWithToken,
  axiosGetWithToken,
  axiosPut,
  axiosPatchWithToken,
} from "../services/apiServices";
import { ERROR_ALERT, SUCCESS_ALERT } from "./commonAction";

export const MP_PROJECT_LAUNCH_LIST = "MP_PROJECT_LAUNCH_LIST";
export const MP_PROJECT_LAUNCH_LOADER = "MP_PROJECT_LAUNCH_LOADER";
export const MP_SET_PROJECTLAUNCH_ITEMS_PER_PAGE =
  "MP_SET_PROJECTLAUNCH_ITEMS_PER_PAGE";
export const MP_CHANGE_CURRENT_PROJECTLAUNCH_PAGE =
  "MP_SET_PROJECTLAUNCH_ITEMS_PER_PAGE";
export const MP_SEARCH_JOBS = "MP_SEARCH_JOBS";
export const MP_CHANGE_CURRENT_PROJECT_PAGE = "MP_CHANGE_CURRENT_PROJECT_PAGE";
export const MP_SET_PROJECT_ITEMS_PER_PAGE = "MP_SET_PROJECT_ITEMS_PER_PAGE";
export const MP_PROJECT_STATUS_FILTER = "MP_PROJECT_STATUS_FILTER";
export const  SET_MP_LAUNCH_DATE_FILTER = "SET_MP_LAUNCH_DATE_FILTER";
export const CLEAR_MP_LAUNCH_DATE_FILTER = "CLEAR_MP_LAUNCH_DATE_FILTER";

export const MP_LAUNCH_NOTES_LOADER = "MP_LAUNCH_NOTES_LOADER";
export const MP_LAUNCH_NOTES_LIST_SUCCESS = "MP_LAUNCH_NOTES_LIST_SUCCESS";
export const MP_LAUNCH_NOTES_LIST_FAIL = "MP_LAUNCH_NOTES_LIST_FAIL";
export const MP_LAUNCH_NOTE_ADD_SUCCESS = "MP_LAUNCH_NOTE_ADD_SUCCESS";
export const MP_LAUNCH_UPDATE_SUCCESS = "MP_LAUNCH_UPDATE_SUCCESS";

export const MP_LAUNCH_OFFER_LOADER = "MP_LAUNCH_OFFER_LOADER";
export const MP_LAUNCH_OFFER_LIST_SUCCESS = "MP_LAUNCH_OFFER_LIST_SUCCESS";
export const MP_LAUNCH_OFFER_LIST_FAIL = "MP_LAUNCH_OFFER_LIST_FAIL";
export const MP_LAUNCH_OFFER_ADD_SUCCESS = "MP_LAUNCH_OFFER_ADD_SUCCESS";

//RENEWALS
export const MP_RENEWAL_LOADER = "MP_RENEWAL_LOADER";
export const MP_RENEWAL_LIST_SUCCESS = "MP_RENEWAL_LIST_SUCCESS";
export const MP_RENEWAL_LIST_FAIL = "MP_RENEWAL_LIST_FAIL";
export const MP_RENEWAL_ADD_SUCCESS = "MP_RENEWAL_ADD_SUCCESS";
export const MP_RENEWAL_UPDATE_SUCCESS = "MP_RENEWAL_UPDATE_SUCCESS";

export const MP_LAUNCH_DETAILS = "MP_LAUNCH_DETAILS";
export const CHANGE_VIEW_MP_LAUNCH_TAB = "CHANGE_VIEW_MP_LAUNCH_TAB";
export const VIEW_AGREEMENT = "VIEW_AGREEMENT"
export const SET_AGREEMENT_TYPE = "SET_AGREEMENT_TYPE";

export const getMPLaunchList = () => {
  return async (dispatch, getState) => {
    dispatch({ type: MP_PROJECT_LAUNCH_LOADER });

    const token = getState().auth.token;
    const {
      mpLaunchCurrentPage,
      mpLaunchSearchText,
      mpLaunchStatusFliter,
      dateFilters,
    } = getState().mpLaunch;

    const bodyData = {
      page_no: mpLaunchCurrentPage,
    };

    if (mpLaunchSearchText) {
      bodyData.search = mpLaunchSearchText;
    }

    // Status handling (your existing logic preserved)
    if (mpLaunchStatusFliter.length === 1) {
      bodyData.status = String(mpLaunchStatusFliter[0]);
    } else if (mpLaunchStatusFliter.length > 1) {
      bodyData.statusus = mpLaunchStatusFliter.map(String);
    }

    // ✅ Add ALL applied date filters dynamically
    Object.entries(dateFilters).forEach(([key, value]) => {
      if (value?.length === 2) {
        bodyData[key] = value;
      }
    });

    axiosPostWithToken(API.MP_LAUNCH_LIST, bodyData, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: MP_PROJECT_LAUNCH_LIST,
            payload: res.data.data,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data || "Something went wrong.",
        });
      });
  };
};

export const setItemsPerPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: MP_PROJECT_LAUNCH_LOADER,
    });
    dispatch({
      type: MP_SET_PROJECTLAUNCH_ITEMS_PER_PAGE,
      payload: value,
    });
  };
};

export const changeCurrentPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: MP_PROJECT_LAUNCH_LOADER,
    });
    dispatch({
      type: MP_CHANGE_CURRENT_PROJECT_PAGE,
      payload: value,
    });
  };
};

export const search = (value) => {
  return async (dispatch) => {
    dispatch({
      type: MP_PROJECT_LAUNCH_LOADER,
    });
    dispatch({
      type: MP_SEARCH_JOBS,
      payload: value,
    });
  };
};

export const editNotes = (id, data, refresh) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosPostWithToken(`${API.EDIT_PROJECT_NOTES}/${id}`, data, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: MP_PROJECT_LAUNCH_LOADER,
          });
          refresh();
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Notes updated Successfully",
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              res.data.data.message ||
              "Something went wrong. Error updating User.",
          });
        }
      }
    );
  };
};

export const setLaunchStatusFliter = (value) => {
  return async (dispatch) => {
    dispatch({
      type: MP_PROJECT_STATUS_FILTER,
      payload: value,
    });
  };
};

export const exportProjectData = (fromDate, toDate) => {
  return async (dispatch, getState) => {
    dispatch({ type: MP_PROJECT_LAUNCH_LOADER });

    const token = getState().auth.token;
    const pageNumber = getState().mpLaunch.mpLaunchCurrentPage;
    const searchText = getState().mpLaunch.mpLaunchSearchText;
    const statusus = getState().mpLaunch.mpLaunchStatusFliter;

    const bodyData = {
      search: searchText,
      page_no: pageNumber,
      from: fromDate,
      to: toDate,
    };

    if (statusus.length === 1) {
      bodyData.status = String(statusus[0]);
    } else if (statusus.length > 1) {
      bodyData.statusus = statusus.map(String);
    }

    const apiUrl = `${API.MP_LAUNCH_LIST_EXPORT}`;

    axiosPostWithToken(apiUrl, bodyData, token, {
      responseType: "blob",
    })
      .then((res) => {
        const blob = new Blob([res.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "mp-data.csv");
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload: err?.response?.data || "Something went wrong.",
        });
      });
  };
};
// Fetch Launch Notes List
export const getLaunchNotes = (launchId) => {
  return async (dispatch, getState) => {
    dispatch({ type: MP_LAUNCH_NOTES_LOADER });

    const token = getState().auth.token;
    const apiUrl = `${API.MP_LAUNCH_NOTE_LIST}/${launchId}`;

    axiosGetWithToken(apiUrl, token)
      .then((res) => {
        const statusCode = res?.data?.status_code;
        const data = res?.data?.data;

        if (statusCode === 200 && Array.isArray(data)) {
          dispatch({
            type: MP_LAUNCH_NOTES_LIST_SUCCESS,
            payload: data,
          });
        } else if (statusCode === 404) {
          dispatch({
            type: MP_LAUNCH_NOTES_LIST_SUCCESS,
            payload: [],
          });

          console.info(" No notes found for this launch.");
        } else {
          dispatch({ type: MP_LAUNCH_NOTES_LIST_FAIL });
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to load notes.",
          });
        }
      })
      .catch((err) => {
        dispatch({ type: MP_LAUNCH_NOTES_LIST_FAIL });
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while fetching notes.",
        });
      });
  };
};

//  Add New Note
export const addLaunchNote = (launchId, note, callback) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const apiUrl = `${API.MP_LAUNCH_CREATE_NOTE}/${launchId}/`;

    const bodyData = {
      notes: note,
    };

    axiosPostWithToken(apiUrl, bodyData, token)
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({
            type: MP_LAUNCH_NOTE_ADD_SUCCESS,
          });

          dispatch(getLaunchNotes(launchId));
          if (callback) callback(); // close dialog etc.
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.message || "Failed to add note.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while adding note.",
        });
      });
  };
};
export const updateLaunchDetails = (launchId, data, callback) => {
  const payload = { ...data };

  // --- DATE FIELDS (must update when cleared) ---
  const dateFields = [
    "latest_start_date",
    "termination_date",
    "tentative_end_date",
    "status",
  ];

  dateFields.forEach((field) => {
    // Convert empty string or undefined to null
    if (payload[field] === "" || payload[field] === undefined) {
      payload[field] = null;
    }
  });

  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const apiUrl = `${API.MP_LAUNCH_LIST_UPDATE}/${launchId}`;

    axiosPostWithToken(apiUrl, payload, token)
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({ type: MP_LAUNCH_UPDATE_SUCCESS });
          dispatch(getMPLaunchList());
          if (callback) callback();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to update launch.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while updating launch.",
        });
      });
  };
};

//Offers
export const getOfferList = () => {
  return async (dispatch, getState) => {
    dispatch({ type: MP_LAUNCH_OFFER_LOADER });

    const token = getState().auth.token;
    const apiUrl = `${API.MP_OFFERS_LIST}`;

    // API expects POST body like this
    const bodyData = {
      search: "",
      page_no: 1,
    };

    axiosPostWithToken(apiUrl, bodyData, token)
      .then((res) => {
        const statusCode = res?.data?.status_code;
        const apiData = res?.data?.data;
        const offers = apiData?.results || [];

        if (statusCode === 200 && Array.isArray(offers)) {
          dispatch({
            type: MP_LAUNCH_OFFER_LIST_SUCCESS,
            payload: offers,
          });
        } else if (statusCode === 404) {
          dispatch({
            type: MP_LAUNCH_OFFER_LIST_SUCCESS,
            payload: [],
          });
          console.info("No offers found.");
        } else {
          dispatch({ type: MP_LAUNCH_OFFER_LIST_FAIL });
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to load offers.",
          });
        }
      })
      .catch((err) => {
        dispatch({ type: MP_LAUNCH_OFFER_LIST_FAIL });
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while fetching offers.",
        });
      });
  };
};
export const createLaunchOffer = (launchId, data, callback) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const apiUrl = `${API.MP_OFFER_CREATE}/${launchId}/`;

    const bodyData = {
      offer: Number(data.offer),
      offer_end_date: data.offer_end_date,
      notes: data.notes?.trim() || "",
      offer_status: String(data.offer_status),
    };
    axiosPostWithToken(apiUrl, bodyData, token)
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Offer added successfully.",
          });
          dispatch(getMPLaunchList());
          if (callback) callback();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to create offer.",
          });
        }
      })
      .catch((err) => {
        console.error("Offer Create Error:", err.response?.data || err.message);
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while adding offer.",
        });
      });
  };
};
//Update existing offer
export const updateLaunchOffer = (launchId, data, callback) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const apiUrl = `${API.MP_OFFER_UPDATE}/${launchId}/`;

    const bodyData = {
      // offer: Number(data.offer),
      ...(data.offer_end_date && { offer_end_date: data.offer_end_date }),
      ...(data.notes?.trim() && { notes: data.notes.trim() }),
      ...(data.offer_status && { offer_status: String(data.offer_status) }),
    };

    axiosPostWithToken(apiUrl, bodyData, token)
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Offer updated successfully.",
          });
          dispatch(getMPLaunchList());
          if (callback) callback();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to Update offer.",
          });
        }
      })
      .catch((err) => {
        console.error("Offer Update Error:", err.response?.data || err.message);
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while updating offer.",
        });
      });
  };
};
export const getRenewalList = (launchId) => {
  return async (dispatch, getState) => {
    dispatch({ type: MP_RENEWAL_LOADER });

    const token = getState().auth.token;
    const apiUrl = `${API.MP_RENEWALS_LIST}/${launchId}/`;

    axiosGetWithToken(apiUrl, token)
      .then((res) => {
        const statusCode = res?.data?.status_code;
        const apiData = res?.data?.data || []; // direct array access
        if (statusCode === 200 && Array.isArray(apiData)) {
          dispatch({
            type: MP_RENEWAL_LIST_SUCCESS,
            payload: apiData,
          });
        } else {
          dispatch({ type: MP_RENEWAL_LIST_FAIL });
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to load renewals.",
          });
        }
      })
      .catch((err) => {
        dispatch({ type: MP_RENEWAL_LIST_FAIL });
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while fetching renewals.",
        });
      });
  };
};
//Create a new renewal
export const createMPRenewal = (launchId, data, callback) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const apiUrl = `${API.MP_RENEWALS_CREATE}/${launchId}/`;

    const bodyData = {
      date_of_renewal: data.date_of_renewal,
      renewal_period: data.renewal_period,
      new_client_pricing: data.new_client_pricing,
      new_candidate_pricing: data.new_candidate_pricing,
      new_job_hours: data.new_job_hours,
      status: data.status,
    };
    axiosPostWithToken(apiUrl, bodyData, token)
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Renewal created successfully.",
          });
          dispatch(getRenewalList(launchId));
          if (callback) callback();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || res?.data?.data?.message || "Failed to create a renewal.",
          });
        }
      })
      .catch((err) => {
        console.error(
          "Renewal Create Error:",
          err.response?.data || err.message
        );
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while creating a renewal.",
        });
      });
  };
};
//Update existing renewal
export const updateMPRenewal = (launchId, data, callback) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const apiUrl = `${API.MP_RENEWALS_UPDATE}/${launchId}/`;

    const bodyData = {
      ...(data.date_of_renewal && { date_of_renewal: data.date_of_renewal }),
      ...(data.renewal_period && { renewal_period: data.renewal_period }),
      ...(data.new_client_pricing && {
        new_client_pricing: data.new_client_pricing,
      }),
      ...(data.new_candidate_pricing && {
        new_candidate_pricing: data.new_candidate_pricing,
      }),
      ...(data.new_job_hours && { new_job_hours: data.new_job_hours }),
      ...(data.status && { status: data.status }),
    };

    try {
      const res = await axiosPut(apiUrl, bodyData, token);

      if (res?.data?.status_code === 200) {
        dispatch({
          type: SUCCESS_ALERT,
          payload: "Renewal updated successfully.",
        });

        // Wait for renewal list to refresh before closing modal
        await dispatch(getRenewalList(launchId));

        // Optionally refresh parent list
        dispatch(getMPLaunchList?.());

        if (callback) callback(); // run callback AFTER the list refresh
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload: res?.data?.message || "Failed to update renewal.",
        });
      }
    } catch (err) {
      console.error("Renewal Update Error:", err.response?.data || err.message);
      dispatch({
        type: ERROR_ALERT,
        payload:
          err?.response?.data?.message ||
          "Something went wrong while updating the renewal.",
      });
    }
  };
};

export const updateCandidateFeedback = (payload, title) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    const apiUrl =
      title === "Client Feedback"
        ? `${API.CLIENT_FEEDBACK}`
        : `${API.CANDIADTE_FEEDBACK}`;
    axiosPostWithToken(apiUrl, payload, token).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: MP_PROJECT_LAUNCH_LOADER,
        });
        dispatch({
          type: SUCCESS_ALERT,
          payload: "Feedback updated Successfully",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message ||
            "Something went wrong. Error updating User.",
        });
      }
    });
  };
};

export const mpLaunchDetails = (id) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosGetWithToken(`${API.MP_LAUNCH_DETAILS}${id}`, token).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: MP_LAUNCH_DETAILS,
          payload: res.data.data,
        });
      } else {
        console.log(`Error: ${res.data.data.message}`);
      }
    });
  };
};

export const updateFeedback = (id,payload, title,refresh) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    const apiUrl =
      title === "Edit Client Feedback"
        ? `${API.UPDATE_CLIENT_FEEDBACK}/${id}/`
        : `${API.UPDATE_CANDIDATE_FEEDBACK}/${id}/`;
    axiosPut(apiUrl, payload, token).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: MP_PROJECT_LAUNCH_LOADER,
        });
  refresh();
        dispatch({
          type: SUCCESS_ALERT,
          payload: "Feedback updated Successfully",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message ||
            "Something went wrong. Error updating User.",
        });
      }
    });
  };
};

export const uploadAgreement = (id,file, agreement) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("agreement_type", agreement)

      const res = await axiosPostWithToken(`${API.UPLOAD_AGREEMENT}${id}/upload-agreement/`,
        formData,
        token
      );

      if (res.data.status_code === 200) {
        dispatch({
          type: SUCCESS_ALERT,
          payload: "File uploaded successfully",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload: res?.data?.data?.message,
        });
      }
    } catch (error) {
      dispatch({
        type: ERROR_ALERT,
        payload: "An error occurred while uploading the file.",
      });
      throw error;
    }
  };
};

export const viewAgreements = (id, agreement) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    axiosGetWithToken(
      `${API.VIEW_AGREEMENT}${id}/${agreement}`,
      token
    )
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: VIEW_AGREEMENT,
            payload: res.data.data,
          });
        } else {
          dispatch({
            type: VIEW_AGREEMENT,
            payload: [], // clear if error
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: VIEW_AGREEMENT,
          payload: [], // clear on failure
        });
        console.log("Error:", error);
      });
  };
};
export const setAgreementType = (type) => ({
  type: SET_AGREEMENT_TYPE,
  payload: type,
});

export const updateIsReplacement= (id, data) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
       const body =  {
        "is_replacement": data
    }
    axiosPatchWithToken(`${API.IS_REPLACEMENT}${id}/replacement`, body, token).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: SUCCESS_ALERT,
          payload: "Updated Successfully",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload: res.data.data.message,
        });
      }
    });
  };
};

